module.exports = __webpack_public_path__ + "static/Rosewater3-a8f383b3cedd7b8eb0d1d8827b5b6013.webp";